"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderRadiusContainerSize = exports.sizeContainer = exports.sizeItem = exports.commonStyle = void 0;
var commonStyle = {
  margin: 'auto',
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0
};
exports.commonStyle = commonStyle;
var sizeItem = {
  small: '10px',
  "default": '12px',
  large: '14px'
};
exports.sizeItem = sizeItem;
var sizeContainer = {
  small: '24px',
  "default": '30px',
  large: '36px'
};
exports.sizeContainer = sizeContainer;
var borderRadiusContainerSize = {
  small: '12px',
  "default": '15px',
  large: '18px'
};
exports.borderRadiusContainerSize = borderRadiusContainerSize;